<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <h3>
                    Clone Prices
                </h3>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-md-12">
                <form class="form" v-on:submit.prevent="handlePriceClonning">
                    <div class="row">
                        <div class="col-md-5">
                            <label for="accomodation">Accomodation</label>
                            <v-select
                                id="accomodation"
                                label="accommodation_name"
                                :options="accomodations_list"
                                placeholder="Select Accomodation"
                                v-model="selected_Accomodation"
                                @change="setAccomodationRoom"
                                required
                            />
                        </div>
                        <div class="col-md-5">
                            <label for="accomodation_room">Room</label>
                            <v-select
                                id="accomodation_room"
                                label="name"
                                index="id"
                                :options="accomodation_room_list"
                                v-model="selectected_accomodation_room_id"
                                placeholder="Select Accomodation Room"
                                required
                            />
                        </div>
                        <div class="col-md-2 mt-4">
                            <div class="form-submit-inline">
                                <button type="submit" class="button">
                                    <span> Clone Prices </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClonePriceModalFields',
    props: {
        accomodation_room_id: Number,
        multiple_price_ids:Array
    },
    data() {
        return {
            accomodations_list: [],
            accomodation_room_list: [],
            selected_Accomodation: {},
            selectected_accomodation_room_id:null
      }  
    },
    created() {
        this.getAccomodations()
    },
    methods: {
        getAccomodations() {
            fetch(this.$api + 'accommodation', {
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if(response.success) {
                    this.accomodations_list = response.data
                }
            });
        },
        setAccomodationRoom() {
            if (this.selected_Accomodation) {
                this.accomodation_room_list = this.selected_Accomodation.accommodation_rooms
            } else {
                this.accomodation_room_list = []
            }
        },
        handlePriceClonning() {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'accommodation/room/handle-prices-clonnig', {
            method: 'post',
            body: JSON.stringify({
                accomodation_room_id: this.selectected_accomodation_room_id,
                selected_price_ids: this.multiple_price_ids
            }),
            headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(response => {
                if(response.status) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });

                    this.selected_Accomodation = {}
                    this.selectected_accomodation_room_id = null
                
                } else {
                    this.$notify({
                    type: 'error',
                    title: response.message
                    });
                }
                
                this.$store.dispatch('setLoadStatus')
            })
        }
    }
}
</script>

<style lang="scss" scoped>

</style>